"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var Loading_1 = require("../globals/Loading");
var vee_validate_1 = require("vee-validate");
var LoadingModule_1 = require("../../store/modules/LoadingModule");
var vuex_module_decorators_1 = require("vuex-module-decorators");
var value_checker_1 = require("../../../common/src/utils/value_checker");
var axios_1 = require("axios");
var room_no_1 = require("../../../common/src/utils/whereby/room_no");
var RoomInfoModule_1 = require("../../store/modules/RoomInfoModule");
var data_parser_1 = require("../../../common/src/utils/data_parser");
var SimpleDialog_1 = require("../globals/SimpleDialog");
var ReservedCol = /** @class */ (function (_super) {
    __extends(ReservedCol, _super);
    function ReservedCol() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentInfo = {};
        _this.showRoomIdError = false;
        _this.roomNoErrorMessage = '';
        _this.roomDuplecate = false;
        _this.roomNoChecked = false;
        _this.roomNoHasError = true;
        _this.roomNo = '';
        _this.roomUrl = '';
        _this.showUpdateSettingDialog = false;
        _this.showClearSettingDialog = false;
        return _this;
    }
    ReservedCol.prototype.dialogClose = function () {
        this.showUpdateSettingDialog = false;
        this.showClearSettingDialog = false;
    };
    ReservedCol.prototype.confirmUpdateSetting = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inputConfirm()];
                    case 1:
                        _a.sent();
                        this.showUpdateSettingDialog = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservedCol.prototype.confirmClearSetting = function () {
        this.showClearSettingDialog = true;
    };
    ReservedCol.prototype.isRoomCreated = function () {
        return value_checker_1.default.isPresent(this.roomUrl);
    };
    ReservedCol.prototype.inputConfirm = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.roomNo) return [3 /*break*/, 2];
                        this.roomNo = data_parser_1.default.toHankaku(this.roomNo);
                        return [4 /*yield*/, this.roomNoChange()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ReservedCol.prototype.isOddCol = function () {
        return (this.week - 1) % 2 !== 0;
    };
    ReservedCol.prototype.propChanged = function () {
        this.currentInfo = this.dayInfo;
        if (this.currentInfo.roomNo) {
            this.roomNo = room_no_1.default.toString(this.currentInfo.roomNo);
        }
        if (this.currentInfo.roomUrl) {
            this.roomUrl = this.currentInfo.roomUrl;
        }
    };
    ReservedCol.prototype.roomNoChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, _a, loading, url_, params, authToken, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        self_ = this;
                        return [4 /*yield*/, this.refs().roomNoValidator.validate()];
                    case 1:
                        _b.sent();
                        _a = this;
                        return [4 /*yield*/, this.refs().roomNoValidator.errors.length];
                    case 2:
                        _a.roomNoHasError = (_b.sent()) > 0;
                        if (this.roomNoHasError) {
                            this.roomNoChecked = false;
                            return [2 /*return*/];
                        }
                        if (this.roomNoChecked) {
                            return [2 /*return*/];
                        }
                        loading = vuex_module_decorators_1.getModule(LoadingModule_1.default, this.$store);
                        loading.setLoading(true);
                        loading.setOverlay(0.5);
                        url_ = self_.$invokeUrlMaker.create('room/check');
                        params = JSON.stringify({
                            officeId: self_.getOfficeId(),
                            roomNo: self_.roomNo
                        });
                        return [4 /*yield*/, this.$cognito.authToken()];
                    case 3:
                        authToken = _b.sent();
                        return [4 /*yield*/, axios_1.default.post(url_, params, {
                                headers: {
                                    Authorization: authToken
                                }
                            })];
                    case 4:
                        result = _b.sent();
                        loading.setLoading(false);
                        if (!result.data['result']) {
                            this.roomDuplicate();
                            return [2 /*return*/];
                        }
                        this.roomNoChecked = true;
                        this.roomDuplecate = false;
                        this.showRoomIdError = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservedCol.prototype.roomDuplicate = function () {
        var self_ = this;
        this.roomNoChecked = false;
        this.roomDuplecate = true;
        this.showRoomIdError = true;
        this.roomNoErrorMessage = String(this.$t('view.host.top.messages.room_duplicate_error'));
        setTimeout(function () {
            self_.showRoomIdError = false;
        }, 3000);
    };
    ReservedCol.prototype.getOfficeId = function () {
        return this.$route.params['office_id'];
    };
    ReservedCol.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refs().roomNoValidator.validate()];
                    case 1:
                        _a.sent();
                        this.roomNoHasError = this.refs().roomNoValidator.errors.length > 0;
                        this.propChanged();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservedCol.prototype.focusOutRoomNo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showRoomIdError = false;
                        return [4 /*yield*/, this.inputConfirm()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservedCol.prototype.startRehabOnline = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, storeInstance, url_, loading, params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        storeInstance = vuex_module_decorators_1.getModule(RoomInfoModule_1.default, this.$store);
                        url_ = self_.$invokeUrlMaker.create('get_room');
                        loading = vuex_module_decorators_1.getModule(LoadingModule_1.default, this.$store);
                        loading.setLoading(true);
                        params = JSON.stringify({
                            officeId: self_.getOfficeId(),
                            roomNo: Number(this.roomNo)
                        });
                        return [4 /*yield*/, axios_1.default.post(url_, params).catch(function (res) {
                                return;
                            })];
                    case 1:
                        result = _a.sent();
                        loading.setLoading(false);
                        if (!result) {
                            return [2 /*return*/];
                        }
                        storeInstance.setMeetingStarted(true);
                        storeInstance.setRoomNo(Number(this.roomNo));
                        storeInstance.setRoomUrl(result.data['roomInfo']['roomUrl']);
                        storeInstance.setHostRoomUrl(result.data['roomInfo']['hostRoomUrl']);
                        return [2 /*return*/];
                }
            });
        });
    };
    ReservedCol.prototype.refs = function () {
        return this.$refs;
    };
    ReservedCol.prototype.buttonDisable = function () {
        return this.roomNoHasError ||
            this.roomDuplecate;
    };
    /**
     *
     */
    ReservedCol.prototype.updateSetting = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, loading, url_, params, authToken, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        self_.showUpdateSettingDialog = false;
                        loading = vuex_module_decorators_1.getModule(LoadingModule_1.default, this.$store);
                        loading.setLoading(true);
                        loading.setOverlay(0.5);
                        url_ = self_.$invokeUrlMaker.create('reserved_room/create');
                        self_.roomNo = data_parser_1.default.toHankaku(self_.roomNo);
                        params = JSON.stringify({
                            officeId: self_.getOfficeId(),
                            roomNo: self_.roomNo,
                            rowIndex: self_.rowIndex,
                            dayIndex: self_.week,
                            memo: self_.currentInfo.memo
                        });
                        return [4 /*yield*/, this.$cognito.authToken()];
                    case 1:
                        authToken = _a.sent();
                        return [4 /*yield*/, axios_1.default.post(url_, params, {
                                headers: {
                                    Authorization: authToken
                                }
                            })];
                    case 2:
                        result = _a.sent();
                        loading.setLoading(false);
                        if (result.data['roomAlreadyCreated']) {
                            this.roomDuplecate = true;
                            this.showRoomIdError = true;
                            this.roomNoErrorMessage = String(this.$t('view.host.top.messages.room_duplicate_error'));
                            return [2 /*return*/];
                        }
                        this.currentInfo.roomNo = result.data['roomNo'];
                        this.currentInfo.roomId = result.data['roomId'];
                        this.currentInfo.roomUrl = result.data['roomUrl'];
                        this.currentInfo.memo = result.data['memo'];
                        this.roomNo = room_no_1.default.toString(result.data['roomNo']);
                        this.roomUrl = result.data['roomUrl'];
                        this.$emit('day-info-updated', { rowIndex: this.rowIndex, dayIndex: this.week, data: this.currentInfo });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     */
    ReservedCol.prototype.clearSetting = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, url_, loading, authToken, params, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self_ = this;
                        self_.showClearSettingDialog = false;
                        url_ = self_.$invokeUrlMaker.create('delete_room');
                        loading = vuex_module_decorators_1.getModule(LoadingModule_1.default, this.$store);
                        loading.setLoading(true);
                        loading.setOverlay(0.5);
                        return [4 /*yield*/, this.$cognito.authToken()];
                    case 1:
                        authToken = _a.sent();
                        params = JSON.stringify({
                            officeId: self_.getOfficeId(),
                            roomNo: self_.roomNo,
                            rowIndex: self_.rowIndex,
                            dayIndex: self_.week
                        });
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, axios_1.default.post(url_, params, {
                                headers: {
                                    Authorization: authToken
                                }
                            })];
                    case 3:
                        _a.sent();
                        this.currentInfo.roomNo = null;
                        this.currentInfo.roomId = '';
                        this.currentInfo.roomUrl = '';
                        this.currentInfo.memo = '';
                        this.roomNo = '';
                        this.roomUrl = '';
                        this.$emit('day-info-updated', { rowIndex: this.rowIndex, dayIndex: this.week, data: this.currentInfo });
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        loading.setLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: 0 })
    ], ReservedCol.prototype, "week", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: 0 })
    ], ReservedCol.prototype, "rowIndex", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], ReservedCol.prototype, "dayInfo", void 0);
    __decorate([
        vue_property_decorator_1.Watch('dayInfo')
    ], ReservedCol.prototype, "propChanged", null);
    ReservedCol = __decorate([
        vue_property_decorator_1.Component({
            components: {
                SimpleDialog: SimpleDialog_1.default,
                Loading: Loading_1.default,
                ValidationProvider: vee_validate_1.ValidationProvider
            }
        })
    ], ReservedCol);
    return ReservedCol;
}(vue_property_decorator_1.Vue));
exports.default = ReservedCol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/reserved/ReservedCol.vue
// module id = AN0M
// module chunks = 1